import React from "react";

const Blog = () => {
  return (
    <section className="blog__section" id="blog">
      <h2 className="section__title">Blog</h2>
      <div className="blog__container container grid">
        <div className="blog__content grid">
          <h2 className="blog__title">Blog</h2>
          <p className="blog__text">
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Vitae,
            eligendi debitis. Accusamus voluptas suscipit eveniet delectus
            aperiam ut enim, cumque iste possimus, ea in omnis praesentium
            facere quia est explicabo numquam dolores dolore ducimus mollitia
            dolor assumenda ullam. Velit repellat non dicta illum omnis ut
            consequatur? Omnis sapiente magnam voluptates blanditiis, laboriosam
            consequuntur, ut culpa labore obcaecati error accusamus animi veniam
            dolor quasi ex ab. Voluptatem quia illum voluptatum esse ipsa nobis
            laudantium rem adipisci minus quasi dolorum natus magni harum
            dolores pariatur labore ab provident ea, cumque nisi autem officia
            porro placeat commodi? Totam tenetur laborum a recusandae nesciunt
            quos quaerat molestias nulla sit. Nisi officia atque vitae
            perferendis quos qui, alias fugit iusto distinctio omnis
            consequatur? Dolorem placeat rem pariatur iure qui itaque totam
            animi vero distinctio nobis, perferendis quia. Esse blanditiis
            rerum, adipisci nihil repellat impedit suscipit veritatis! Illum
            libero cupiditate nesciunt illo rerum. Totam, culpa error.
          </p>
        </div>
      </div>
    </section>
  );
};

export default Blog;
